import { render, staticRenderFns } from "./SimilarityPopOver.vue?vue&type=template&id=327d03fc&"
import script from "./SimilarityPopOver.vue?vue&type=script&lang=ts&"
export * from "./SimilarityPopOver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports